<!-- 密码管理 -->
<template>
  <div class="phone-container">
    <div class="tab-view">
      <div
        style="
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e0e0e0;
        "
      >
        <div class="tab-item" style="margin-right: 50px" @click="tabAction(1)">
          <div :style="tab == 1 ? ' color: #488eff' : ''">登录密码</div>
          <div class="tab-line" v-show="tab == 1"></div>
        </div>
        <div class="tab-item" @click="tabAction(2)">
          <div :style="tab == 2 ? ' color: #488eff':''">交易密码</div>
          <div class="tab-line" v-show="tab == 2"></div>
        </div>
      </div>
    </div>
    <div class="hint-view">
      <img src="@/assets/image/hint-image.png" alt="" />
      <label>
        {{tab==1?'登录密码由6-20位字母、数字两种或以上组成':'您当前进行的是重置交易密码的操作，请先验证身份'}}
      </label>
    </div>
    <div  v-if="pageData.isSetLoginPassword&&tab==1 ||pageData.isSetFundPassWord&&tab==2" class="binding-view">
      <img src="../../assets//image/sub-suc-ico.BB4Wd5EJ.png" alt="">
      <div style="font-size: 25px; font-weight: 500; padding: 20px 0px;">{{tab==1?'登录密码已开启':'交易密码已开启'}} </div>
      <el-button type="primary"  @click="resetClick">重置密码</el-button>
    </div>
    <div class="phone-container-view" v-else>
      <div class="input-phone">

        <div class="input-item">
          <div style=" flex-shrink: 0; width: 150px;"> 手机号:</div>
          <div>{{userData.mobile}}</div>
        </div>

        <div class="input-item" style="margin-top: 40px">
          <div style="flex-shrink: 0; width: 150px;"> {{tab == 1?'登录密码':'交易密码'}} :</div>
          <el-input
            v-model="form.password"
            :placeholder="tab==1?'6-20位包含字母 数字 特殊符号至少两种':'6-20位包含字母 数字 特殊符号至少两种'"
            style="width: 300px;flex-shrink: 0;"
          ></el-input>
        </div>
        <div class="input-item" style="margin-top: 40px">
          <div style="flex-shrink: 0; width: 150px; flex-shrink: 0;">短信验证码：</div>
          <el-input
            v-model="form.captcha"
            placeholder="请输入短信验证码"
            style="width: 300px;flex-shrink: 0;"
          ></el-input>
          <span
            class="suffix"
            style="margin-left: -90px; z-index: 999"
            @click="captcha"
            >{{
              isCaptchaDisabled ? `${captchaCountdown}秒后重试` : "获取验证码"
            }}</span
          >
        </div>
        <div class="input-item" style="margin-top: 40px">
          <div style="padding-right: 90px"></div>
          <el-button type="primary" style="margin-top: 20px" @click="pwdupdate"
            >保存</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
   
   <script>
import http from "@/utils/http/axios";
export default {
  data() {
    return {
      passwordRegex:  /^.{6,20}$/,
      input: "",
      tab: localStorage.getItem('tab')?localStorage.getItem('tab'):1,
      captchaCountdown: 60, // 倒计时总秒数
      isCaptchaDisabled: false, // 按钮禁用状态
      form: {},
      pageData :undefined,
    };
  },
  props: {
			  userData: Object
		},
    mounted() {
      this.getUserInfo();
    },
  methods: {
    changePhomeClick(vl) {},
    // 切换类型
    tabAction(vl) {
      this.tab = vl;
      localStorage.removeItem('tab')
    },
    //密码更新验证码
    captcha() {
      http
        .get("/user/pwd/captcha?pwdType=" + this.tab)
        .then((response) => {
          if (response.code == 200) {
            this.$message("发送成功");
            this.startCaptchaCountdown();
          } else {
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },

    // 更新密码
    pwdupdate() {
      if (!this.form.password) {
        this.$message.error("请输入登录密码");
        return;
      }
      if (!this.form.captcha) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!this.passwordRegex.test(this.form.password)) {
        this.$message.error(
          "密码必须是6-20位"
        );
        return;
      }
      this.form.platform = "3";
      this.form.pwdType = this.tab;
      http.post("/user/pwd/update", this.form).then((response) => {
        if (response.code == 200) {
          this.$message.success("修改成功");
          this.form.password = "";
          this.form.captcha = "";
          this.captchaCountdown =  60
          this. isCaptchaDisabled=false
          this.getUserInfo()
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    // 点击重置密码
    resetClick(){
      if( this.tab == 1){
        this.pageData.isSetLoginPassword = false
      }else{
        this.pageData.isSetFundPassWord = false
      }
    },
    // 开始倒计时
    startCaptchaCountdown() {
      this.isCaptchaDisabled = true;
      let countdown = this.captchaCountdown;
      const interval = setInterval(() => {
        countdown--;
        if (countdown <= 0) {
          clearInterval(interval);
          this.isCaptchaDisabled = false;
          this.captchaCountdown = 60; // 重置倒计时
        } else {
          this.captchaCountdown = countdown;
        }
      }, 1000);
    },
    // 用户信息
    getUserInfo() {
      http
        .get("/user/base/info")
        .then((response) => {
          if (response.code === 200) {
            this.pageData = response.data;
            
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
  },
};
</script>
   
<style lang="scss" scoped>
.hint-view {

  height: 40px;
  margin: 0 20%;;
  margin-top: 50px;
  color: rgb(169, 83, 0);
  background: rgb(255, 244, 219);
  display: flex;
  align-items: center;
  font-size: 12px;
  color: rgb(169, 83, 0);
  padding: 0px 20px;
  border-radius: 10px;
  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
}
.tab-view {
  width: 100%;
  margin-top: 20px;
  padding: 0 20%;
  .tab-item {
    color: #000000a5;
    font-size: 16px;
    position: relative;
    padding-bottom: 15px;
  }
  .tab-line {
    position: absolute;
    bottom: 0;
    left: 8px;
    right: 8px;
    height: 5px;
    border-top-left-radius: 2.5px;
    border-top-right-radius: 2.5px;
    background-color: #488eff;
  }
}

.phone-container {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  padding-bottom: 30px;
  .binding-view{
    margin: 30px 25%;
    display: flex;
    flex-direction: column;
    align-items: center;

  }
  .phone-container-view {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    .user-phone {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 240px;
        height: 146px;
      }
      color: #1f1f1f;
      font-size: 20px;
      font-weight: 700;
    }
    .input-phone {
      padding: 30px 25%;
      display: flex;
      flex-direction: column;
      width: 100%;
      .input-item {
        display: flex;
        align-items: center;
      }
    }
    .bottom-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 30px 350px;

      .bottom-title {
        color: #000000e0;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
      }
      .bottom-label {
        color: #000000a6;
        font-family: PingFang SC, sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
      }
    }
  }
  .link {
    padding-left: 10px;
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
    color: #488eff !important;
  }
}
.suffix {
  margin-left: -75px; /* 与输入框间隔 */
  z-index: 99;
  color: #488eff;
  flex-shrink: 0;
}
</style>